export default __webpack_public_path__ + "static/item_07-bc8fe31b1abea341d36ba9f3ab15ec6b.jpg";